<!--
 * @Description: 人员审核详情接单科室组件
 * @Author: fengal
 * @Date: 2024-06-04 12:01:35
-->
<template>
  <div class="baseinfo-wrap">
    <div class="header-wrap" :class="review && isGlobalAdmin && (!review.status || review.status == 2) ? 'sticky' : ''">
      <div class="header" :style="{'align-items' : !isFold && (reviewType == 2 || reviewType == 4 || reviewType == 10) ? 'flex-start' : 'center'}">
        <img class="header-image" src="../../../../assets/instmng/attendantlist/img-attendant-acceptinfo.png" alt="" />
        <div style="flex: 1">
          <span>接单科室</span>
          <div v-if="!isFold && review && reviewHistoryFold">
            <div class="review-status-text-wrap">
              <span class="circle-dot" :class="review.status == 2 ? 
              'refuse-status': 'routine-status'">
              </span>
              <span :class="review.status == 2 ? 'refuse-text': 'routine-text'">
                {{review.statusText}}
              </span>
              <span class="more-btn-wrap" v-if="reviewHistoryList && reviewHistoryList.length > 1" 
                @click="reviewHistoryFold = false">
                <span>更多</span>
                <img src="../../../../assets/reviewmng/icon-attendant-review-more.png" alt="">
              </span>
            </div>
            <div class="review-text">
              <div v-if="review.status == 0 || review.status == 3">
                <span>
                  {{review.status == 3 ? '撤回人：' : '提交人：'}}
                </span>
                <span>
                  {{review.submiterText ? review.submiterText : '- -'}}
                </span>
                <span style="margin-left: 35px">
                  {{review.status ==  3 ? '撤回时间：' : '提交时间：'}}
                </span>
                <span>
                  {{review.status ==  3 ? review.cancelTime : review.submitTime}}
                </span>
              </div>
              <div v-else>
                <div style="font-size: 13px">
                  <span>审核意见：</span>
                  <span>{{review.comment ? review.comment : '- -'}}</span>
                </div>
                <p>
                  <span>审核人：</span>
                  <span>{{review.reviewerText ? review.reviewerText : '- -'}}</span>
                  <span style="margin-left: 35px">审核时间：</span>
                  <span>{{review.reviewTime ? review.reviewTime : '- -'}}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="review-history-timeline" v-if="!isFold && !reviewHistoryFold">
            
          </div>
        </div>
      </div>
      <div v-if="isFold" @click="isFold = !isFold" class="header-right">
        <img style="width: 20px;height: 15px;margin-right: 5px;"
          src="../../../../assets/instmng/attendantlist/icon-attendant-unfold.png" alt="">
          展开查看
      </div>
      <div v-else-if="!isFold" class="review-btn-container">
        <div v-if="review && isGlobalAdmin && (!review.status || review.status == 2)">
          <span class="status-button adopt-btn" @click="handleReviewAttendant('approve')">
            <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-pass.png"
              alt="" />
            <span style="margin-left: 2px">通 过</span>
          </span>
          <span class="status-button" v-if="!review.status" style="background: #e04a52; cursor: pointer"
            @click="handleReviewAttendant('reject')">
            <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-nopass.png"
              alt=""/>
            <span style="margin-left: 2px">驳 回</span>
          </span>
        </div>
      </div>
    </div>
    <div class="body" v-if="!isFold">
      <span>医院列表</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["baseInfo", "reviewType", "review", "reviewHistoryList", "isGlobalAdmin"],

  data() {
    return {
      isFold: this.reviewType == 2 || this.reviewType == 4 
        || this.reviewType == 10 ? false : true,   //是否折叠页面内容
      reviewHistoryFold: true,
    }
  },

  methods: {
    handleReviewAttendant(reviewStatus) { 
      this.$emit("handle-attendant-review", reviewStatus, this.review.version);
    },
  },

  
};
</script>

<style scoped>
.baseinfo-wrap {
  background: #f7f9fe;
  padding-left: 25px;
  margin: 0 25px 20px 25px;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f7f9fe;
}

.sticky {
  position: sticky;
  top: 50px;
  z-index: 300;
}

.header {
  margin: 30px 0;
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  color: #000000;
  font-size: 22px;
  flex: 1;
}

.header-image {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}

.header-right {
  background: #F1F5FF;
  height: 120px;
  color: #3E7EF5;
  width: 177px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.review-status-text-wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1BAA60;
  margin: 10px 0 3px 0;
}

.review-text {
  color: #657180;
  font-size: 14px;
  background: rgba(186,186,186,0.1);
  margin-left: 32px;
  padding: 11px 20px 11px 6px;
  font-weight: 400;
}

.body {
  padding: 5px 260px 0 40px;
  display: flex;
  align-items: flex-start;
}

.baseinfo-wrap /deep/ .el-descriptions__body {
  background: #f7f9fe;
}
.baseinfo-wrap /deep/ .el-descriptions-item__cell {
  padding-bottom: 16px;
}

.idcard-image {
  width: 280px;
  height: 180px;
  background-color: #EBEEF2;
}

.idcard-wrap {
  text-align: center;
}
.idcard-wrap p {
  color: #666666;
  font-size: 13px;
  margin-top: 10px;
}

.drop-icon {
  width: 28px;
  display: inline-block;
  color: #FFFFFF;
  height: 100%;
  background: #66B1FE;
  line-height: 39px;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
}

.review-btn-container {
  padding-right: 20px;
  width: 240px;
  margin-top: 37px;
}
.status-button {
  display: inline-block;
  width: 98px;
  height: 31px;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
}

.review-btn-icon {
  width: 18px;
  height: 20px;
  vertical-align: middle;
}

.adopt-btn {
  background: #3e7ef6;
  cursor: pointer;
  margin-right: 25px;
}

.circle-dot {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 10px;
  color: #999999;
  background: #1BAA60;
}

.more-btn-wrap {
  font-size: 13px;
  font-weight: 400;
  color: #3E7EF6;
  margin-left: 44px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.more-btn-wrap img {
  height: 20px;
  width: 20px;
  margin-left: 5px;
}

.review-history-timeline {
  padding-top: 10px;
}

.review-history-timeline /deep/ .el-timeline {
  padding: 0;
}

.review-history-timeline /deep/ .el-timeline-item__wrapper {
  top: 0;
}

.review-history-timeline /deep/ .el-timeline-item__node--large {
  height: 22px;
  width: 22px;
}

.review-history-timeline /deep/ .el-timeline-item__tail {
  left: 8px;
  border-left: 3px solid #1baa60;
}

.review-history-text {
  font-size: 14px;
  line-height: 20px;
}

.review-content-text-wrap {
  color: #657180;
  font-size: 13px;
  font-weight: 400;
}

.review-content-text-wrap div {
  color: #657180;
  font-size: 14px;
  background: rgba(186,186,186,0.1);
  padding: 11px 20px 11px 6px;
  font-weight: 400;
}

.review-content-text-wrap p,.review-text p {
  margin: 0;
  margin-top: 10px;
  font-size: 14px;
}

.routine-status {
  background: #1BAA60;
}
.refuse-status {
  background: #FF0909;
}

.routine-text {
  color: #1BAA60;
}
.refuse-text {
  color: #FF0909;
}

.signedHospital {
  width: 760px;
  margin-left: 70px;
  background: #fff;
  display: flex;
  border: 1px solid #e7e7e7;
}
.hspList,
.deptList {
  /* max-height: 180px; */
  max-height: 360px;
  overflow-y: auto;
  /* padding: 0 15px; */
}
.hspList {
  width: 315px;
}
.deptList {
  flex: 1;
}
.title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  color: #5b5b5b;
  font-size: 16px;
  margin-bottom: 10px;
}
.hsp {
  padding: 10px 15px;
}
.activeHsp {
  background: #f4f7ff;
  cursor: pointer;
}
.commonHsp {
  background: #fff;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/attendantReviewDetails/AttendantReviewAcceptInfo.vue